import { useState } from 'react'
import style from './style.module.css'
import CloseBubbleIcon from '../../../../../assets/svgs/CloseBubble'
import Cookies from 'js-cookie'

import axios from 'axios'

const CreateEnterpriseModal = ({ handleClose }) => {
  const url = process.env.REACT_APP_API_URL || ''
  const isSuperUser = Cookies.get('isSuperUser') === 'true'

  const [formData, setFormData] = useState({
    name: '',
    employee_count: '',
    monthly_active_users: '',
    website_url: '',
    location: '',
    sector: '',
    technology_domains: [],
    admin_id: '',
  })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState('')

  const handleInputChange = (e) => {
    const { name, value } = e.target

    if (name === 'technology_domains') {
      setFormData({
        ...formData,
        [name]: value.split(','),
      })
    } else {
      setFormData({ ...formData, [name]: value })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess('')

    try {
      setLoading(true)

      const { data } = await axios.post(
        `${url}/enterprise/register`,
        formData,
        {
          withCredentials: true,
          headers: {
            Accept: 'application/json',
            'X-Is-SuperUser': isSuperUser ? 'true' : 'false',
          },
        }
      )

      setSuccess(data.message)

      setFormData({
        name: '',
        employee_count: '',
        monthly_active_users: '',
        website_url: '',
        location: '',
        sector: '',
        technology_domains: [],
        admin_id: '',
      })
    } catch (error) {
      setError(error.response?.data?.error || 'An error occurred')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={style.container}>
      <div className={style.closeBubble} onClick={handleClose}>
        <CloseBubbleIcon />
      </div>

      <h2 className={style.title}>Create Enterprise</h2>

      <form className={style.form} onSubmit={handleSubmit}>
        <div className={style.inputContainer}>
          <input
            type="text"
            className={style.inputField}
            placeholder="Name"
            value={formData.name}
            onChange={handleInputChange}
            name="name"
            required
          />
        </div>

        <div className={style.inputContainer}>
          <input
            type="number"
            className={style.inputField}
            placeholder="Employee Count (number)"
            value={formData.employee_count}
            onChange={handleInputChange}
            name="employee_count"
            required
          />
        </div>

        <div className={style.inputContainer}>
          <input
            type="number"
            className={style.inputField}
            placeholder="Monthly Active Users (number)"
            value={formData.monthly_active_users}
            onChange={handleInputChange}
            name="monthly_active_users"
            required
          />
        </div>

        <div className={style.inputContainer}>
          <input
            type="text"
            className={style.inputField}
            placeholder="Website Url"
            value={formData.website_url}
            onChange={handleInputChange}
            name="website_url"
            required
          />
        </div>

        <div className={style.inputContainer}>
          <input
            type="text"
            className={style.inputField}
            placeholder="Location"
            value={formData.location}
            onChange={handleInputChange}
            name="location"
            required
          />
        </div>

        <div className={style.inputContainer}>
          <input
            type="text"
            className={style.inputField}
            placeholder="Sector"
            value={formData.sector}
            onChange={handleInputChange}
            name="sector"
            required
          />
        </div>

        <div className={style.inputContainer}>
          <input
            type="text"
            className={style.inputField}
            placeholder="Technology Domains (divided by ,)"
            value={formData.technology_domains}
            onChange={handleInputChange}
            name="technology_domains"
            required
          />
        </div>

        <div className={style.inputContainer}>
          <input
            type="text"
            className={style.inputField}
            placeholder="Admin Id"
            value={formData.admin_id}
            onChange={handleInputChange}
            name="admin_id"
            required
          />
        </div>

        <div className={style.buttonContainer}>
          {error && (
            <div className={style.errorMessage}>
              <span>{error}</span>
            </div>
          )}

          {success && (
            <div className={style.successMessage}>
              <span>{success}</span>
            </div>
          )}

          <button className={style.button} disabled={loading}>
            {loading ? 'Creating...' : 'Create New'}
          </button>
        </div>
      </form>
    </div>
  )
}

export default CreateEnterpriseModal
